<!-- 由 woniu6162 创建于 2021-10-19 星期二 -->
<template>
  <div class="inner-rank">
    <pHead :datum="headDatum" />
    <div class="ir_body">
      <div class="ir_b_tabs">
        <template v-for="(item, index) in headList">
          <div
            :key="index"
            :class="['ir_bt_name', curTab == item.id ? 'ir_bt_is' : '']"
            @click="curTab = item.id"
          >
            {{ item.name }}
          </div>
        </template>
      </div>
      <div class="ir_b_wrap">
        <div v-if="refresh_time" class="ir_bw_time">{{ refresh_time }}</div>
        <template v-if="curTab == 'producerRank'">
          <pProducer :datum="listDatum" />
        </template>
        <template v-else-if="curTab == 'videoRank'">
          <pVideo :datum="listDatum" />
        </template>
        <template v-else>
          <pCards :datum="listDatum" />
        </template>
        <van-empty
          v-if="!listDatum.length"
          image="search"
          description="暂无数据"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { headList } from './data.js'
import pHead from './ponents/p-head.vue'
import pCards from './ponents/p-cards.vue'
import pProducer from './ponents/p-producer.vue'
import pVideo from './ponents/p-video.vue'
export default {
  name: 'inner-rank',

  mixins: [],

  components: { pHead, pCards, pProducer, pVideo },

  props: {},

  data() {
    return {
      headList,
      headDatum: { date: new Date() },
      refresh_time: '',
      listDatum: [],
      curTab: 'videoRank'
    }
  },

  computed: {},

  watch: {
    curTab() {
      this.loadDatum()
    },
    'headDatum.date'() {
      this.loadDatum()
    }
  },

  created() {},

  mounted() {
    this.loadDatum()
  },

  destroyed() {},

  methods: {
    loadDatum() {
      this.$toast.loading('加载')
      let params = { date: this.headDatum.date || new Date() }
      this.listDatum = []
      this.$http
        .getApp(`member/douyin/${this.curTab}`, params)
        .then((rs) => {
          this.$toast.clear()
          if (rs.data.code == 200) {
            let result = rs.data.data
            this.listDatum = result.data
            this.refresh_time = result.notice
          }
        })
        .catch(() => this.$toast.clear())
    }
  }
}
</script>

<style lang="scss" scoped>
.inner-rank {
  min-height: 100vh;
  box-sizing: border-box;
  position: relative;
  background: #f7f7f7;
  .ir_body {
    margin-top: -2.7vw;
    position: relative;
    z-index: 1;
    .ir_b_tabs {
      width: 100vw;
      height: 16vw;
      background-color: #fff;
      border-radius: 2.7vw 2.7vw 0 0;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .ir_bt_name {
        font-size: 3.7vw;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.5);
      }
      .ir_bt_is {
        color: #000;
        position: relative;
        display: flex;
        justify-content: center;
        &::after {
          content: '';
          width: 6.4vw;
          height: 1.1vw;
          background-color: #ff5a5a;
          position: absolute;
          bottom: -5.6vw;
        }
      }
    }
    .ir_b_wrap {
      .ir_bw_time {
        padding: 3.2vw 3.2vw 0;
        font-size: 3.5vw;
        color: rgba(0, 0, 0, 0.5);
      }
    }
  }
}
</style>
